import { createFileRoute, Outlet } from "@tanstack/react-router"

import { internalRouteGuard } from "~/utils/routeGuards"

/**
 * Single staff gate for the entire `/internal` section. Every `/internal/**`
 * route inherits this `beforeLoad`, so internal tooling is Hakio-staff-only by
 * default — new pages don't need to remember their own guard. Staff-ness comes
 * from the JWT role claim via `internalRouteGuard` (see `~/utils/routeGuards`).
 */
export const Route = createFileRoute("/_auth/internal")({
  beforeLoad: internalRouteGuard,
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
